import { render, staticRenderFns } from "./TopUpDepositsList.vue?vue&type=template&id=33c0aede"
import script from "./TopUpDepositsList.vue?vue&type=script&lang=js"
export * from "./TopUpDepositsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports